import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.CodigoCliente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCliente=${params.CodigoCliente}`);
  params.CodigoEstado &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.CodigoEstado}`);
  params.CodigoCotizacion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCotizacion=${params.CodigoCotizacion}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta && (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${params.FechaHasta}`);

  return path;
};
